<template>
  <BrToolBar @search="buscar" :configFilter="configFilter" :addlFilter="addlFilter" :labelTextField="labelTextField">
    <BrModalCadastro />
  </BrToolBar>
</template>

<script>
/**
 * MIXIN
 */
import toolbar from '@/views/mixins/toolbar'

export default {
  name: `BrToolBarCadastroRole`,
  mixins: [toolbar],
  components: { 
    BrModalCadastro: () => import('./modalCadastro'),
    BrToolBar: () => import('@/views/components/toolbar/newToolbar')
  }
}
</script>